import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const TypesOfBirth = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Donut
            title={'Tipos de Partos'}
            subtitles={chartData?.typesOfBirth?.map((item) => item.description)}
            chartData={chartData?.typesOfBirth || []}
            colors={defaultColors.slice(0, chartData?.typesOfBirth?.length) || []}
            height={350}
        />
    );
};
